import React, { useState } from 'react';
import { connect } from 'react-redux';
import toast from "react-hot-toast";
import moment from 'moment'
import { Box } from '@mui/material'

import AddSuperUserAutocomplete from '../../../common/CustomInput/addSuperUserAutocomplete'
import CustomActionButton from '../../../common/CustomActionButton';

import { AddNewSuperUserToList } from '../../../redux/superUser/actions';
import { apiCallV2 } from '../../../utils/api'
import { delay } from '../../../utils';

let timer = null
const AddSuperUser = (props) => {
    const { setOpenAddSuperUser } = props;
    // autocomplete states
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;

    const [selected, setSelected] = useState('')

    const handleConfirm = async () => {
        const res = await apiCallV2("POST", "admin/add-user-to-super-user", selected, localStorage.getItem("access-token"));

        if (res.data.status === 200) {
            toast.success('Added to super-user')

            delay(() => {
                setOpenAddSuperUser(false)
            }, 2000)

            props.AddNewSuperUserToList(res.data?.superUser);

            return true;
        }
        if (res.data.status === 500) {
            toast.error(res.data.message)
            return false;
        }
    }

    // fetch all users to select for super user
    const handleOptions = async (value) => {
        setOptions([])
        clearTimeout(timer)
        timer = setTimeout(async () => {

            const res = await apiCallV2(
                "GET",
                "get-users",
                "",
                localStorage.getItem("access-token"),
                {
                    page: null,
                    count: null,
                    filters: { search: value, admin_id: null }
                },
            );

            setOptions(res.data.users)
        }, 600)

    }

    return (
        <div id="add-super-user-form">
            <Box display="flex" sx={{ justifyContent: 'center' }}>
                <AddSuperUserAutocomplete handleOptions={handleOptions} open={open} setOpen={setOpen} loading={loading} setOptions={setOpen} options={options} setSelected={setSelected} />
            </Box>
            {selected ? (
                <div>
                    <h5>
                        {selected?.first_name} {selected?.last_name}  {selected?.dob && ("- DOB: " + moment(selected?.dob).format('MMM-DD-YYYY'))}
                    </h5>
                    <h5>
                        {selected?.name}
                    </h5>
                    <div className='add-su-action'>
                        <CustomActionButton action={handleConfirm}>SUBMIT</CustomActionButton>
                    </div>

                </div>
            ) :
                ''
            }
        </div>
    );
};


const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    AddNewSuperUserToList,
})(AddSuperUser);
